const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  progressContainer: {
    padding: '32px',
    backgroundColor: '#F8FAFC',
    borderRadius: '16px',
    border: '1px solid #E2E8F0',
    textAlign: 'center',
  },
  progressBar: {
    height: '10px',
    borderRadius: '5px',
    backgroundColor: '#E2E8F0',
    '& .MuiLinearProgress-bar': {
      borderRadius: '5px',
      backgroundColor: '#3B82F6',
    },
  },
  checklist: {
    marginTop: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  checklistItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #F1F5F9',
    borderRadius: '12px',
    transition: 'all 0.2s',
  },
  checklistText: {
    fontSize: '14px',
    color: '#475569',
    flex: 1,
  },
  checklistDone: {
    backgroundColor: '#F0F9FF',
    borderColor: '#BAE6FD',
    '& $checklistText': {
      color: '#0369A1',
      fontWeight: 500,
    },
  },
  spinner: {
    color: '#3B82F6',
    animation: '$rotate 1s linear infinite',
  },
  '@keyframes rotate': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  successCard: {
    padding: '32px',
    backgroundColor: '#F0FDF4',
    border: '1px solid #BBF7D0',
    borderRadius: '16px',
    textAlign: 'center',
  },
})

export default styles
